jQuery(document).ready(function($) {
  function masonryGrid() {
    var $container = $('.grid-gallery')
    $container.masonry({
      itemSelector: '.gallery-grid-item',
      columnWidth: '.grid-sizer', //as you wish , you can use numeric
      gutter: 20,
      isAnimated: true,
    })
    // $container.imagesLoaded(function () {
    // // initialize

    // });
  }

  if ($('.grid-gallery').length > 0) {
    masonryGrid()
  }
})
